import { SideCart, SideSheet, SnackBar } from '@desquared/wave-components-library';
import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import Router, { useRouter } from 'next/router';
import { isUndefined, isEmpty } from 'lodash';
import { fetchCart } from '@/api/syncCart';
import { IsAddressModalOpen } from '../../store/addressModal';
import CartStore, { productsForOrder, cartPrice, fullCartStore, hasCartUpdated } from '../../store/cart';
import { isCartErrorSnackBarOpen } from '@/store/cartErrorSnackBar';
import GuestUserStore from '../../store/guestUser';
import { Shop } from '../../store/shop';
import User from '../../store/user';
import { priceChangesModalStore } from '@/store/priceChangesStore';
import { openListSideSheet, openProductDetails } from '@/utils/products';
import useBundleOffersSummary from '@/hooks/useBundleOffersSummary';
import { DeliveryServicesContext } from '@/contexts/DeliveryServicesContext';
import getLayoutProps from '@/utils/layout/layout';
import EmptyState from '../../../public/assets/wave-grocery/Empty-States-Default/Empty-Cart.png';
import { ListAdditionSheetStore } from '@/store/sideSheet';
import DefaultProductImage from '../../../public/assets/wave-grocery/Empty-States-Default/DefaultProductImage.png';
import Cookies from 'universal-cookie';
import {
  getDelivery,
  checkOrder,
  checkProducts,
  ORDER_LIMIT,
  onAdd,
  onRemove,
  setCartProducts,
  setDiscounts,
  onRemoveAll,
  updateCartOrder,
  calculateOrderLimit,
} from '@/utils/products/products';
import { useTranslations } from 'next-intl';
import { CurrencyContext } from '@/contexts/CurrencyProvider';
import { arraysEqual } from '@/utils/helpers';
import useGetDefaultProductImage from '@/hooks/useGetDefaultProductImage.js';
import { compact } from 'lodash';
import isBoolean from 'lodash/isBoolean';
import { useConfiguration } from '@/contexts/ConfigContext';
import { ErrorModalStore } from '@/store/errorModalStore';

export default function SideCartSheet() {
  const [isCartVisible, setIsCartVisible] = useState(CartStore.getIsVisble$);
  const [productsFiltered, setProductsFiltered] = useState([]);
  const [tempProducts, setTempProducts] = useState([]);
  const [totalPrice, setTotalPrice] = useState('');
  const defaultProductImage = useGetDefaultProductImage();
  const [remove, setRemove] = useState(true);
  const [formattedTitle, setFormatedTitle] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const [showSnackBar, setShowSnackBar] = useState(false);
  // const [fetchNewCart, setFetchNewCart] = useState(true);
  const [changeQuantity, setChangeQuantity] = useState(false);
  const { config } = useConfiguration();
  const [image, setImage] = useState();
  const [data, setData] = useState();
  const refOne = useRef(null);
  const { getCollectionTypes, selectedUserAddressIndex, selectedShop, selectedService } =
    useContext(DeliveryServicesContext);
  const { bundleOffersSummary } = useBundleOffersSummary();
  const [selectedProduct, setSelectedProduct] = useState({});
  const [listAddtion, setListAddition] = useState();
  const [initialLoad, setInitialLoad] = useState(true);
  const [orderRestrictionsBannerConfig, setOrderRestrictionsBannerConfig] = useState({
    isVisible: false,
    status: 'success',
    text: '',
    secondaryText: '',
    assistive: '',
  });
  const [checkOrderValidForSubmit, setCheckOrderValidForSubmit] = useState(false);
  const [trigger, setTrigger] = useState(false);
  const handleClickOutside = e => {
    if (refOne.current && !refOne.current.contains(e.target) && !ListAdditionSheetStore.getValue()) {
      CartStore.setIsVisible(false);
    }
  };
  const router = useRouter();
  const { formatter } = useContext(CurrencyContext);

  const t = useTranslations('common.asides.side_cart');
  const r = useTranslations('common');
  const a = useTranslations('common.asides');
  const cookies = new Cookies();
  const authorization = cookies.get('token');

  const headerTitle = t('header');
  const productValueLabel = t('product_value_label');
  const finalSumDescription = t('final_sum_description');
  const buttonLabel = t('btn_label');

  const onClose = () => {
    setIsCartVisible(false);
    CartStore.setIsVisible(false);
    setInitialLoad(true);
  };
  async function onSubmit() {
    const user = User.getValue();
    const guestUser = GuestUserStore.getValue();

    if (!user?._id && !config?.order?.guest?.enabled) {
      onClose();
      router.push('/login', '/login');
      return;
    }
    if (!selectedShop) {
      isCartErrorSnackBarOpen.update(true);
      return;
    }
    if (data?.order?.products?.length === 0 || productsForOrder.getValue()?.length === 0) {
      onClose();
      router.push('/categories', '/categories');
      return;
    }
    const collectionType = getCollectionTypes();
    const value = await checkOrder(
      tempProducts,
      'none',
      false,
      collectionType?.length > 0 ? collectionType : [process.env.defaultCollectionType],
      selectedUserAddressIndex,
      bundleOffersSummary,
      false,
      [],
      selectedProduct,
      setSelectedProduct,
      t('no_comment'),
      formatter,
      t('unavailable_product'),
      a
    );
    fullCartStore.update(value);

    if (guestUser?.address && !user && config?.order?.guest?.enabled) {
      onClose();
      router.push('/cart', '/cart');
      return;
    }

    if (User.getValue()?.address?.length === 0 && guestUser?.address === 'undefined') {
      if (getDelivery() === 'takeAway') {
        SideSheetStore.open();
      } else {
        IsAddressModalOpen.update('open');
        return;
      }
    }
    if (data?.progress?.code !== 'undefined' && data?.progress?.code !== ORDER_LIMIT) {
      if (checkProducts()) {
        priceChangesModalStore.update(true);
      } else {
        onClose();
        router.push('/cart', '/cart');
      }
    }
  }

  useEffect(() => {
    async function initializeSidecart() {
      setTrigger(false);
      // Fetch and set layout properties
      const layoutProps = await getLayoutProps({ headerProps: { selectedIndex: -1 } }, Router.locale);
      const image = layoutProps?.emptyStates?.cart_empty_state?.url || null;
      setImage(image);

      // Initialize shop and subscriptions
      Shop.lazyInit();
      const cartIsVisible$ = CartStore.getIsVisble$().subscribe(_cartVisible => {
        setIsCartVisible(_cartVisible);
      });

      const productsForOrder$ = productsForOrder.subscribe((productsOrder = []) => {
        const tempProducts = setCartProducts(productsOrder);
        setTempProducts(tempProducts);
      });

      document.addEventListener('click', handleClickOutside, true);

      const cartPrice$ = cartPrice.subscribe(setTotalPrice);
      const $listAddition = ListAdditionSheetStore.subscribe(setListAddition);

      return () => {
        $listAddition.unsubscribe();
        cartIsVisible$.unsubscribe();
        cartPrice$.unsubscribe();
        document.removeEventListener('click', handleClickOutside, false);
        productsForOrder$.unsubscribe();
      };
    }
    initializeSidecart();
  }, [productsForOrder]);

  useEffect(() => {
    const sub = productsForOrder.subscribe(products => {
      if (products && selectedService) {
        if (!isEmpty(selectedService?.orderLimitsCalculation?.maxCartItemsAllowed)) {
          // Reset state
          setOrderRestrictionsBannerConfig({
            isVisible: false,
            status: 'success',
            text: '',
            secondaryText: '',
            assistive: '',
          });
        }

        const orderRestrictions = calculateOrderLimit(products, selectedService);
        let status = 'success';
        let assistive = '';
        if (orderRestrictions?.used / orderRestrictions.limit >= 0.8) status = 'warning';
        if (orderRestrictions.isAtOrOverLimit) status = 'danger';
        if (orderRestrictions?.used / orderRestrictions.limit > 1)
          assistive = r('header.express_modal.assistive', { limit: orderRestrictions.limit });

        setOrderRestrictionsBannerConfig({
          isVisible: !isEmpty(selectedService?.orderLimitsCalculation?.maxCartItemsAllowed),
          status: status,
          text: `${selectedService?.title} ${orderRestrictions?.used}/${orderRestrictions.limit}`,
          secondaryText: r('header.express_modal.header.secondary'),
          assistive,
        });
      }
    });

    return () => sub.unsubscribe();
  }, [selectedService, setOrderRestrictionsBannerConfig]);

  useEffect(() => {
    async function handleCartChanges() {
      if (isBoolean(isCartVisible) && isCartVisible) {
        setIsLoading(true);
        if (data?.products?.length > 0) {
          const updatedData = { ...data };
          const productIndex = selectedProduct
            ? updatedData.products.findIndex(el => {
                if (el?.ingredients?.length && selectedProduct?.ingredients?.length) {
                  return el.id === selectedProduct.id && arraysEqual(el.ingredients, selectedProduct.ingredients);
                }

                return el.id === selectedProduct.id;
              })
            : 0;

          if (productIndex >= 0) updatedData.products[productIndex].isLoading = true;
          setData(updatedData);
        }
        let newProducts = [];
        async function fetchCartData() {
          try {
            const result = await fetchCart(); // Wait for API response
            const validProducts = result?.data?.products?.filter(item => item?.productId); // Filter out invalid items
            return validProducts;
          } catch (error) {
            console.error('Failed to fetch cart data:', error);
          } finally {
            // setTrigger(true);
          }
        }
        // if (!isEmpty(authorization) && process.env.NEXT_PUBLIC_SYNC_CART === 'true') {
        //   if ((!trigger && !changeQuantity) || hasCartUpdated.getValue()) {
        //     newProducts = await fetchCartData();
        //   }
        // }
        const collectionType = getCollectionTypes();

        if (tempProducts.length > 0 || changeQuantity) {
          await checkOrder(
            tempProducts,
            'none',
            false,
            collectionType?.length > 0 ? collectionType : [process.env.defaultCollectionType],
            selectedUserAddressIndex,
            bundleOffersSummary,
            false,
            [],
            selectedProduct,
            setSelectedProduct,
            t('no_comment'),
            formatter,
            t('unavailable_product'),
            a,
            newProducts && newProducts.length && !changeQuantity && !hasCartUpdated.getValue() ? newProducts : []
          )
            .then(result => {
              if (result && result.error) {
                ErrorModalStore.update(true);
                onClose();
              }
              if (result && result.data) {
                setCheckOrderValidForSubmit(
                  !(result?.data?.messages?.[0]?.code === 'MSG_ORDER00034' && !result?.data?.isValidForSubmit)
                );
                const productIndex = selectedProduct
                  ? result.products.findIndex(el => {
                      if (el?.ingredients?.length && selectedProduct?.ingredients?.length) {
                        return el.id === selectedProduct.id && arraysEqual(el.ingredients, selectedProduct.ingredients);
                      }

                      return el.id === selectedProduct.id;
                    })
                  : 0;

                if (productIndex >= 0 && result.products[productIndex]) {
                  result.products[productIndex].isLoading = false;
                }
                setData(result);

                if (result?.progress) {
                  const { title, data } = result.progress;
                  setFormatedTitle(
                    data?.remainingAmountForFree
                      ? title
                          .replace('{remainingAmountForFree}', data.remainingAmountForFree.toFixed(2))
                          .replace('{currency}', data.currency)
                      : title.replace('{remainingAmount}', data.remainingAmount).replace('{currency}', data.currency)
                  );
                }
              }
            })
            .finally(() => {
              setChangeQuantity(false);
              hasCartUpdated.update(false);
              setIsLoading(false);
              setInitialLoad(false);
              setTotalPrice(
                (
                  (data?.data?.order?.orderItemsPriceWithoutDiscounts -
                    setDiscounts(data?.data?.order?.discounts, 'PRODUCTS')) /
                  100
                ).toFixed(2)
              );
            });
        }
        setIsLoading(false);
        if (!isEmpty(authorization) && process.env.NEXT_PUBLIC_SYNC_CART === 'true' && changeQuantity) {
          await updateCartOrder(tempProducts, 'none', false, t('no_comment'));
        }
        if (
          tempProducts.length === 0 &&
          productsForOrder.getValue().length === 0 &&
          !isEmpty(authorization) &&
          process.env.NEXT_PUBLIC_SYNC_CART === 'true'
        ) {
          updateCartOrder([], 'none', true, t('no_comment'));
          cartPrice.update('0.00');
        }

        const flag = data?.order?.products?.length > 0;
        setProductsFiltered(flag ? data?.order?.products : tempProducts);
      }
    }
    handleCartChanges();
  }, [isCartVisible, remove, listAddtion, trigger, tempProducts, productsForOrder]);

  const sideCartItems = useMemo(() => {
    if (!data?.products) return [];

    if (config?.catalog?.product?.packagingFee?.enabled) {
      return data?.products?.map(prod => {
        const matchedProduct = data?.data?.order?.products?.find(item => item.productId === prod.id);
        if (matchedProduct?.packagingProductId && matchedProduct?.packagingUnitPrice) {
          return {
            ...prod,
            packagingProductId: matchedProduct?.packagingProductId,
            packagingUnitPrice: formatter.format(Number(matchedProduct?.packagingUnitPrice / 100)),
            packagingProductName: matchedProduct?.packagingProductName,
          };
        } else return prod;
      });
    } else return data?.products;
  }, [data, config]);

  if (!isCartVisible) return;

  return (
    <div ref={refOne}>
      <SideSheet position="right">
        <SideCart
          orderLimitBannerConfiguration={orderRestrictionsBannerConfig}
          headerTitle={headerTitle}
          hasProgressBar={!isUndefined(data?.progress)}
          progressBarDescription={!isUndefined(data?.progress) && formattedTitle}
          progressBarProgress={
            (data?.progress?.progressInfo?.currentValue * 100) / data?.progress?.progressInfo?.requiredValue
          }
          content={{
            items: sideCartItems,
            empty: sideCartItems.length === 0,
            emptyTitle: sideCartItems.length === 0 && t('empty_title'),
            emptyText: sideCartItems.length === 0 && t('empty_text'),
            emptyImg: image ? image : EmptyState.src,
          }}
          productValueLabel={
            data?.data?.order?.fees?.some(el => el.type === 'SHIPPING_COST')
              ? data?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0].title
              : undefined
          }
          productValue={
            data?.data?.order?.fees?.some(el => el.type === 'SHIPPING_COST')
              ? formatter.format(data?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount / 100)
              : undefined
          }
          finalSumDescription={finalSumDescription}
          finalSumValue={
            !isUndefined(data?.data?.order) && data?.products?.length > 0
              ? formatter.format(
                  (data?.data?.order?.orderItemsPriceWithoutDiscounts -
                    setDiscounts(data?.data?.order?.discounts, 'PRODUCTS') +
                    (data?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount
                      ? data?.data?.order?.fees?.filter(el => el.type === 'SHIPPING_COST')[0]?.amount
                      : 0)) /
                    100
                )
              : formatter.format(totalPrice)
          }
          buttonLabel={buttonLabel}
          onClose={onClose}
          actionButtons={[
            {
              btnLabel: t('btn_label'),
              onClick: () => onSubmit(),
              variant: 'filled',
              key: 'filled',
              disabled:
                data?.data?.messages?.some(el => el.code === 'MSG_ORDER00017') ||
                (isLoading ? true : false) ||
                !checkOrderValidForSubmit,
            },
          ]}
          onChange={(id, ingredients) => {
            onAdd(id, setTempProducts, setRemove, remove, data, setSelectedProduct, ingredients);
            setChangeQuantity(true);
          }}
          onRemove={(id, ingredients) => {
            onRemove(id, setTempProducts, setRemove, remove, null, setSelectedProduct, ingredients);
            setChangeQuantity(true);
          }}
          onAddList={item => {
            openListSideSheet(item);
          }}
          onOpenDetails={item => {
            openProductDetails(item);
          }}
          disabled={!isLoading || data?.products?.length > 0}
          isLoading={isLoading && initialLoad}
          setMaxSnackBar={setShowSnackBar}
          listButtonText={r('lists_tile_item')}
          removeButtonText={r('remove_all_tile_item')}
          removeAll={(id, ingredients) => {
            onRemoveAll(id, setTempProducts, setRemove, remove, null, setSelectedProduct, ingredients);
            setChangeQuantity(true);
          }}
          progressBarEmoji={data?.data?.messages?.some(el => el.code === 'MSG_ORDER00017') ? '🙄' : '🚚'}
          defaultProductImage={defaultProductImage}
          isPackagingFeeEnabled={config?.catalog?.product?.packagingFee?.enabled}
        />
      </SideSheet>
      <SnackBar open={showSnackBar} setOpen={setShowSnackBar} text={r('snackbar')} position={'center'} />
    </div>
  );
}
